import $ from "jquery";

export function InitializeVideoWidget() {
    $(".video-widget").each(function () {
        const $videoWidget = $(this);
        const $videoImage = $videoWidget.find(".video-widgetThumbnail");
        if ($videoImage.length) {
            $videoWidget
                .find(".video-widgetImg")
                .attr("src", `//img.youtube.com/vi/${$videoWidget.data("video-id")}/hqdefault.jpg`);
            $videoImage.removeClass("is-placeholder");
        }

        $videoWidget.on("click", function () {
            if ($videoWidget.data("video-popup") === "True") {
                const videoDialog = $(`<dialog class="[ dialog --fit ]">
                    <div class="group">
                    <header style="display: contents;"><close-dialog-button class="absolute top-4 right-4 hidden group-hover:block" color="var(--color-main-glow)"></close-dialog-button></header>
                    <iframe type="text/html"
                          src="${$videoWidget.data("video-url")}"
                          width="${$videoWidget.data("width") === "" ? "854" : $videoWidget.data("width")}"
                          height="${$videoWidget.data("height") === "" ? "480" : $videoWidget.data("height")}"
                          frameborder="0"
                          allowfullscreen>
                    </iframe></div>
                </dialog>`)[0] as HTMLDialogElement;

                document.body.appendChild(videoDialog);
                videoDialog.addEventListener("close", () => {
                    document.body.removeChild(videoDialog);
                });
                videoDialog.showModal();
            } else {
                const $videoWidgetHeight = $videoWidget.height();
                $videoWidget.replaceWith(`<div>
              <iframe type="text/html"
                      src="${$videoWidget.data("video-url")}"
                      width="100%"
                      height="${$videoWidgetHeight}"
                      frameborder="0"
                      allowfullscreen
                      class="videoAspect">
                </iframe>
            </div>`);
            }
        });
    });
}

window.InitializeVideoWidget = InitializeVideoWidget;

$(function () {
    InitializeVideoWidget();
});
